import { pgaComTld } from "../components/utils"

export const PTM_LEGACY_APPLICATION_PATHS = [
  "/applications/associate",
  "/applications/affiliate",
  "/applications/associate/edit",
  "/applications/affiliate/edit",
]

export const MEMBER_APPLICATIONS_URL = `https://${pgaComTld}/member/account/applications`

export const shouldSuppressPtmLegacyApplicationRoute = path =>
  PTM_LEGACY_APPLICATION_PATHS.includes(path)

export const redirectToMemberApplications = () => {
  window.location.href = MEMBER_APPLICATIONS_URL
}
